import Swiper, { Navigation, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

export function setupProductImages() {
    const productDetailsMedia = document.querySelector('.product-details__media');

    if (productDetailsMedia) {
        const numberOfMedias = productDetailsMedia.querySelectorAll('.product-details__image-wrap').length;

        if (numberOfMedias > 1) {
            const parent = document.querySelector('.product-details__media');
            const children = document.querySelectorAll('.product-details__media picture');
            const steps = parent.querySelector('.product-details__media-steps');

            parent.innerHTML = '';

            const wrapper = document.createElement('div');
            wrapper.classList.add('swiper-wrapper');

            Array.from(children).forEach(child => {
                child.classList.add('swiper-slide');
                wrapper.appendChild(child);
            });

            const prev = document.createElement('div');
            prev.classList.add('product-details__media-control', 'product-details__media-control--prev');

            const next = document.createElement('div');
            next.classList.add('product-details__media-control', 'product-details__media-control--next');

            const swiperDOM = document.createElement('div');
            swiperDOM.classList.add('swiper');
            swiperDOM.appendChild(wrapper);

            parent.appendChild(swiperDOM);
            parent.appendChild(prev);
            parent.appendChild(next);
            parent.appendChild(steps);

            const fractionEl = steps.querySelector('.current');

            const swiper = new Swiper(swiperDOM, {
                pagination: {
                    type: 'fraction',
                    el: fractionEl
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev
                }
            });
        }
    }
}
